export const projects = [
  {
    id: 1,
    title: "Online E-Shopping Web Store",
    description: "A full-featured online store with cart functionality and payment processing.",
    tags: ["Web", "Fullstack", "java", "HTML", "CSS", "javascript", "serverlet", "Mysql"],
    image: "/assets/images/projects/online web store.jpg",
    github: "https://github.com/sathirapramudith123/online-E-shopping-web-store-.git",
  
  },
  {
    id: 2,
    title: "Tic Tac Toe Game",
    description: "Tic Tac Toe is a simple two-player game played on a 3×3 grid. Players take turns marking a square with their symbol — either X or O — aiming to place three of their marks in a horizontal, vertical, or diagonal row to win. If all nine squares are filled without a winner, the game ends in a draw.",
    tags: ["Web", "Mobile", "Java"],
    image: "/assets/images/projects/tic tac.png",
    github: "https://github.com/sathirapramudith123/Tic-Tac-Toe-Game-.git",
    
  },
  {
    id: 3,
    title: "Food Delivery  Website",
    description: "A fully functional Food Delivery Website built using HTML, CSS, JavaScript, PHP, and MySQL. This project allows users to browse menus, place online food orders, and manage their accounts. It includes features for customers, restaurant admins, and delivery personnel, offering an end-to-end food ordering experience.",
    tags: ["Web", "HTML", "CSS", "JavaScript", "PHP", "MySQL", "Fullstack"],
    image: "/assets/images/projects/Food_Delivery.png",
    github: "https://github.com/sathirapramudith123/Food-Delivery-Web-Site.git",
    
  },
  {
    id: 4,
    title: "SpringBoot AI",
    description: "A simple Spring Boot application demonstrating integration with Artificial Intelligence features, likely intended for experimenting with or building intelligent applications using React and Spring Boot.",
    tags: ["Web","Springboot", "Realtime", "React.js", "OpenAPI", "AI"],
    image: "/assets/images/projects/AI-chat-5.png",
    github: "https://github.com/sathirapramudith123/Spring-Boot-AI.git"
  },
  {
    id: 5,
    title: "Snake Game",
    description: "A classic Snake Game where players control a snake to eat food, grow longer, and avoid running into walls or itself. The game features simple controls and increasing difficulty as the snake grows.",
    tags: ["Design", "C++"],
    image: "/assets/images/projects/snake game.png",
    github: "https://github.com/sathirapramudith123/snake-game.git"
  },
  {
    id: 6,
    title: "ToDo App",
    description: "A simple ToDo application built with Kotlin for Android. It allows users to create, manage, and delete tasks, providing a user-friendly interface and smooth user experience.",
    tags: ["Mobile", "Kotlin", "Android"],
    image: "/assets/images/projects/To-Do-List-App.jpg",
    github: "https://github.com/sathirapramudith123/TODO-app-android-studio-.git"
  },
  {
    id: 7,
    title: "Object Detection",
    description: "A simple yet powerful real-time object detection system using YOLOv3 and OpenCV. This project demonstrates the integration of deep learning with computer vision to detect and classify objects from webcam or video input.",
    tags: ["Web",  "Python", "OpenCV", "AI"],
    image: "/assets/images/projects/original.png",
    github: "https://github.com/sathirapramudith123/object-detect-system.git"
  },
  {
    id: 8,
    title: "Chess Game",
    description: "A Java-based Chess Game built as part of a programming project to simulate the classic game of chess. This repository contains all the source code needed to run a simple chess game following standard chess rules.",
    tags: ["Web","Fullstack",  "Java", "OOP", ],
    image: "/assets/images/projects/chess game.jpg",
    github: "https://github.com/sathirapramudith123/Chess_Game-.git"
  },
  
  {
    id: 9,
    title: "Google Map",
    description: "This project demonstrates how to integrate Google Maps with a React JS application. It showcases key functionalities like adding markers, customizing maps, and interacting with map events. This project is ideal for developers looking to incorporate Google Maps into their React-based projects.",
    tags: ["Web","Fullstack",  "JavaScript", "React", ],
    image: "/assets/images/projects/google map.jpg",
    github: "https://github.com/sathirapramudith123/Google-Map-React-Js.git"
  },
];